import { render, staticRenderFns } from "./ModalChoisirFournisseur.vue?vue&type=template&id=1b3c6bfb&"
import script from "./ModalChoisirFournisseur.vue?vue&type=script&lang=js&"
export * from "./ModalChoisirFournisseur.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b3c6bfb')) {
      api.createRecord('1b3c6bfb', component.options)
    } else {
      api.reload('1b3c6bfb', component.options)
    }
    module.hot.accept("./ModalChoisirFournisseur.vue?vue&type=template&id=1b3c6bfb&", function () {
      api.rerender('1b3c6bfb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Commandes/ModalChoisirFournisseur.vue"
export default component.exports